import React from 'react';

import dayjs from 'dayjs';

import ContentCard from '../../../../../components/ContentCard';
import ContentGroupsList from '../../../../../components/ContentGroupsList';
import { Student, WaitlistedClass } from '../../../../../services/students/types';
import { SUBJECTS } from '../../../../../utils/common/constants';

interface WaitlistCardProps {
  student?: Student;
}

const WaitlistCard = ({ student }: WaitlistCardProps) => (
  <ContentCard
    variant="outlined"
    title="Waitlist"
  >
    <ContentGroupsList
      columns={[
        {
          field: 'subject',
          headerName: 'Subject',
          width: 160,
          renderCell: (params) => {
            const { subject } = params.row;
            return SUBJECTS[subject].label;
          },
        },
        {
          field: 'classId',
          headerName: 'Class Name',
          width: 160,
        },
        {
          field: 'addedDatetime',
          headerName: 'Date Added',
          width: 120,
          renderCell: (params) => dayjs(params.value).format('DD MMM \'YY'),
        },
      ]}
      data={(student?.waitlistedClasses || [])}
      loading={false}
      getRowHref={(row: WaitlistedClass) => `/admin/class/${row.subject}/${row.classId}`}
      getRowId={(row: WaitlistedClass) => row.classId}
    />
  </ContentCard>
);
export default WaitlistCard;
